import * as d3 from "d3";
import { differenceInMinutes } from "date-fns";
import moment from "moment";

import {
  getRangeFormat,
  timeFormats,
  timeframeToRange
} from "src/organization/pages/project/environment/metrics/components/Chart/settings";
import { TimeFrameType } from "src/organization/pages/project/environment/metrics/resources/types";

/**
 * Get the number of ticks that should be shown on x-axis in a way
 * that does not overlap over cluster too close together
 * @param axisWidth number the width of the axis
 * @param timeFrame TimeFrameType the current selected timeframe
 * @param itemSpacing spacing to be applied between labels
 * @returns number the tick counts for the axis
 */
export const getXTickCount = (
  axisWidth: number = 300,
  timeFrame?: TimeFrameType,
  itemSpacing: number = 19
) => {
  const range = timeframeToRange(timeFrame);
  const timeUnit = getRangeFormat(range);

  const rangeMinutes = moment(range.start).diff(range.end, "minutes");
  const fmt = timeFormats[rangeMinutes ? timeUnit : "tooltip"];
  const format = (d: Date) =>
    d.getHours() === 0 && d.getMinutes() === 0
      ? d3.timeFormat("%d %b")(d)
      : fmt(d);
  //assume each character is 5.2px wide
  const labelWidth = format(new Date()).length * 6;

  const maxItems = axisWidth / labelWidth;
  const maxSpace = maxItems * itemSpacing;
  let count = Math.floor((axisWidth - maxSpace) / labelWidth);

  if (rangeMinutes === 0) {
    const seconds = moment(range.end).diff(range.start, "seconds");
    count = seconds > 0 ? Math.min(count, seconds) : 1;
  }

  return { count, format };
};

export const getDistanceToPreload = (timeFrame?: TimeFrameType) => {
  const { start, end } = timeframeToRange(timeFrame);
  const minutes = differenceInMinutes(end, start);
  const margin = 10 + minutes * 0.1;
  return {
    rootMargin: `${margin}px`,
    margin
  };
};
